// extracted by mini-css-extract-plugin
export default {"chevronRow":"YahooChevronIndicators_chevronRow__NAXfK","chevron":"YahooChevronIndicators_chevron__ZWdaM"};